import { ApplicationConfig, provideZoneChangeDetection, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { requestAuthInterceptor, responseInterceptor, SPECTRUM_API_PATH, SPECTRUM_AUTH_API, provideSpectrumGuide } from 'common';
import { environment } from '../environments/environment';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
    LayoutDashboard, PenLine, FileText, BarChart3, Layers, BookOpen,
    GraduationCap, Settings, ChevronDown, ChevronRight, ChevronLeft,
    Plus, Check, X, Menu, Bell, Calendar, ClipboardList, Eye, Zap,
    Award, Trash2, Save, Send, Lock, Unlock, PanelLeftClose, PanelLeftOpen,
    LayoutGrid, Users, AlertCircle, Copy, LogOut, CalendarDays, CalendarOff, Ban, Info,
    CalendarPlus, CheckCircle, SlidersHorizontal, Medal, Baby, MessageSquare
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideSpectrumGuide({
            module: 'academics',
            title: 'Academics',
            manual: () => import('./help/academics.manual').then(m => m.ACADEMICS_MANUAL)
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([requestAuthInterceptor, responseInterceptor])),
        provideAnimations(),
        { provide: SPECTRUM_API_PATH, useValue: environment.externalApiPath },
        { provide: SPECTRUM_AUTH_API, useValue: environment.authBaseUrl },
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                LayoutDashboard, PenLine, FileText, BarChart3, Layers, BookOpen,
                GraduationCap, Settings, ChevronDown, ChevronRight, ChevronLeft,
                Plus, Check, X, Menu, Bell, Calendar, ClipboardList, Eye, Zap,
                Award, Trash2, Save, Send, Lock, Unlock, PanelLeftClose, PanelLeftOpen,
                LayoutGrid, Users, AlertCircle, Copy, LogOut, CalendarDays, CalendarOff, Ban, Info,
                CalendarPlus, CheckCircle, SlidersHorizontal, Medal, Baby, MessageSquare
            })
        }
    ]
};
